<template>
    <div class="header" style="text-align: center; font-family:'Helvetica'">
        <h1
            style="
                text-align: center;
                font-weight: 300;
                font-family: 'Times New Roman';
                color: rgb(15, 76, 133);
                font-size: 2em;
            "
        >
        <span class="text-muted" style="color: #a0a0a0">Formacast.org/</span>Livecoach
        </h1>
        <p style="margin: 10px; font-size:0.9em ; font-family: 'Helvetica';">
            {{ 
                this.$i18n.t(title)
            }}
       
        </p>
        <p style="font-size:0.9em; font-family: 'Helvetica';">
            {{ 
                this.$i18n.t(secondaryTitle)
            }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'FormHeader',
    props: {
        title: {
            type: String,
            default: "Bienvenue sur Formacast !"
        },
        secondaryTitle: {
            type: String,
            default: 'Connectez-vous pour accéder à votre compte',
        },
    },
    
}
</script>
